import React from 'react';
export const UserContext = React.createContext({
  setUserData: (user) => {},
  curUser: {},
});
